import React from 'react';
import Modal from '../Modal/Modal';
import styles from './ShareModal.scss';
import { PageOwnerAvatar } from '../PageOwnerAvatar/PageOwnerAvatar';
import {
  FacebookShareRound,
  TwitterShareRound,
  EmailShareRound,
  WhatsAppShareRound,
  SMSShareRound,
} from '../SocialButtons';
import isMobile from '../../utils/isMobile';

export interface ShareModalProps {
  onClose: () => void;
  heading: string;
  description: string;
  shareItems: {
    facebook: { url: string };
    twitter: { url: string; message: string };
    whatsApp: { message: string };
    sms: { message: string };
    email: {
      subject: string;
      body: string;
    };
  };
}

export const ShareModal: React.FunctionComponent<ShareModalProps> = ({
  onClose,
  shareItems,
  heading,
  description,
}) => {
  const isMobileDevice = isMobile(window);

  return (
    <Modal onCloseRequest={onClose} className={styles.modal} displayCloseButton>
      <div className={`row ${styles.topContainer}`}>
        <div className="col-md-3">
          <PageOwnerAvatar />
        </div>
        <div className={`col-md-9 ${styles.description}`}>
          <h2 className={`jg-h2 ${styles.title}`}>{heading}</h2>
          <p>{description}</p>
        </div>
      </div>
      <ul className={styles.list}>
        <li className={styles.listItem}>
          <FacebookShareRound url={shareItems.facebook.url} />
        </li>
        <li className={styles.listItem}>
          <TwitterShareRound
            message={shareItems.twitter.message}
            url={shareItems.twitter.url}
          />
        </li>
        <li className={styles.listItem}>
          <EmailShareRound
            body={shareItems.email.body}
            subject={shareItems.email.subject}
          />
        </li>
        {isMobileDevice && (
          <>
            <li className={styles.listItem}>
              <WhatsAppShareRound message={shareItems.whatsApp.message} />
            </li>
            <li className={styles.listItem}>
              <SMSShareRound message={shareItems.sms.message} />
            </li>
          </>
        )}
      </ul>
    </Modal>
  );
};
